import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import type { Reminder } from '@/types';

export function useReminders(itemId: string) {
  const [reminders, setReminders] = useState<Reminder[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from('reminders')
      .select('*')
      .eq('item_id', itemId)
      .order('next_due_date');
    setReminders((data ?? []) as Reminder[]);
    setLoading(false);
  }, [itemId]);

  useEffect(() => { load(); }, [load]);

  return { reminders, loading, reload: load };
}

export function useAllReminders(familyId: string | undefined) {
  const [reminders, setReminders] = useState<Reminder[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!familyId) { setReminders([]); setLoading(false); return; }
    const { data } = await supabase
      .from('reminders')
      .select('*')
      .eq('family_id', familyId)
      .eq('is_active', true)
      .order('next_due_date');
    setReminders((data ?? []) as Reminder[]);
    setLoading(false);
  }, [familyId]);

  useEffect(() => { load(); }, [load]);

  return { reminders, loading, reload: load };
}
